import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { PaperProps, Typography } from "@material-ui/core";

// Icons
import LocalAtmRoundedIcon from "@material-ui/icons/LocalAtmRounded";

// NPM
import clsx from "clsx";

// Components
import StyledOutlinedPaperWrapper from "../common/OutlinedPaperWrapper.Component";

// Classes
import Utility from "../../domain/classes/Utility";
import { useApplicationManager } from "../../contexts/ApplicationManager.Context";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
	});

export interface PaymentReceivedReminderProps extends PaperProps {}

const PaymentReceivedReminder = React.forwardRef<
	HTMLDivElement,
	PaymentReceivedReminderProps & WithStyles<typeof styles>
>(({ classes, className, ...paperProps }, ref) => {
	const { selectedApptType } = useApplicationManager();

	return (
		<StyledOutlinedPaperWrapper
			{...paperProps}
			ref={ref}
			className={clsx(classes.root, className)}
		>
			<LocalAtmRoundedIcon color="primary" />
			<Typography variant="body1">
				<strong>
					Deposit of ${selectedApptType.preDepositAmount.toFixed(2)}
				</strong>
				&nbsp;has been successfully paid.
			</Typography>
		</StyledOutlinedPaperWrapper>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("PaymentReceivedReminder"),
})(PaymentReceivedReminder);
